import {
  SET_ACTIVE_SELECTOR_VALS,
} from '../constants/actionTypes';

import {
  LegendAction
} from '../actions/legendActions';

export const initialState = {
  isEditLegendVisible: [false],
  isEditing: false,
  isFetching: false,
  maxValue: null,
  minValue: null,
  steps: null,
};

/**
 * Handles redux state for edit legend
 * @param {Object} state
 * @param {Object} action
 * @return {Object} new state
 */
// TODO - Remove SonarQube disablement after BTR-931 is done.
function legendReducer(state = initialState, action) {
  // NOSONAR
  switch (action.type) {
    case LegendAction.DecrementSteps:
      return {
        ...state,
        steps: state.steps > 3 ? state.steps - 1 : 3,
      };
    case LegendAction.EditLegend:
      return {
        ...state,
        isEditing: true,
        isFetching: true,
      };
    case LegendAction.EditLegendFailure:
      return {
        ...state,
        isEditLegendVisible: [false],
        isFetching: false,
      };
    case LegendAction.IncrementSteps:
      return {
        ...state,
        steps: state.steps < 12 ? state.steps + 1 : 12,
      };
    case LegendAction.ReceiveEditLegend:
      return {
        ...state,
        isEditing: false,
      };
    case LegendAction.ReceiveLegend:
      return {
        ...state,
        isEditLegendVisible: [false],
        isFetching: false,
      };
    case LegendAction.RequestLegend:
      return {
        ...state,
        isFetching: true,
      };
    case SET_ACTIVE_SELECTOR_VALS:
      return {
        ...state,
        isEditLegendVisible: [false],
      };
    case LegendAction.SetMaxValue:
      return {
        ...state,
        maxValue: action.value,
      };
    case LegendAction.SetMinValue:
      return {
        ...state,
        minValue: action.value,
      };
    case LegendAction.SetSteps:
      return {
        ...state,
        steps: action.value,
      };
    case LegendAction.ToggleEditLegend: {
      const isEditLegendVisible = state.isEditLegendVisible.map((view, index) =>
        action.index === index ? !view : view
      );
      if (action.index >= state.isEditLegendVisible.length) {
        isEditLegendVisible[action.index] = true;
      }
      return {
        ...state,
        isEditLegendVisible,
      };
    }
    default:
      return state;
  }
}

export default legendReducer;
